import { Constants } from '@pwc/pwc-deals-web-common';
import { NavLink, useLocation } from 'react-router-dom';
import { useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './TermsAndConditionsTabs.module.scss';

type Props = {
  urlPart: string;
  text: string;
};

export const Tab = ({ urlPart, text }: Props) => {
  const liElement = useRef<HTMLAnchorElement>(null);
  const location = useLocation();

  const linkUrl = `/policies/${urlPart}`;

  useEffect(() => {
    if (location.pathname === linkUrl) {
      liElement.current?.scrollIntoView({ block: 'nearest', inline: 'center' });
    }
  }, [location.pathname, linkUrl, liElement]);

  return (
    <NavLink
      to={linkUrl}
      data-testid={`terms-and-conditions-tab-${urlPart}`}
      className={styles.link}
      ref={liElement}
      tabIndex={location.pathname === linkUrl ? -1 : undefined}
    >
      {text}
    </NavLink>
  );
};

const TermsAndConditionsTabs = () => {
  const { t } = useTranslation();
  return (
    <div className={styles.wrapperOuter}>
      <div className={styles.wrapper}>
        <div className={styles.tabList}>
          {Constants.TERMS_AND_CONDITIONS_LINKS.map((link) => (
            <Tab key={link.key} urlPart={link.key} text={t(link.key)} />
          ))}
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditionsTabs;
